import * as Msal from "msal";
import CryptoJS from "crypto-js";
import axios from "axios";
import { notification } from "antd";
import config from "../../config/api";
// import { setToken } from '../../config/axios';
import {
  loginRequest,
  loginSuccess,
  loginFailure,
} from "../../redux/actions/Auth/AuthActions";
import { history } from "../../History";

var msalConfig = {
  auth: {
    clientId: "f35099db-2620-4588-8d86-1256dc78f53f", //This is your client ID
    authority:
      "https://login.microsoftonline.com/058ffa1f-5c51-45d3-89a5-cff53e844deb", //This is your tenant info
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
};

var graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};

// create a request object for login or token request calls
// In scenarios with incremental consent, the request object can be further customized
var requestObj = {
  scopes: ["user.read"],
};

var myMSALObj = new Msal.UserAgentApplication(msalConfig);

// Register Callbacks for redirect flow
// myMSALObj.handleRedirectCallbacks(acquireTokenRedirectCallBack, acquireTokenErrorRedirectCallBack);
myMSALObj.handleRedirectCallback(authRedirectCallBack);

export const signIn = (dispatch) => {
  myMSALObj
    .loginPopup(requestObj)
    .then(function (loginResponse) {
      //Successful login

      //Call MS Graph using the token in the response
      acquireTokenPopupAndCallMSGraph(dispatch);
    })
    .catch(function (error) {
      //Please check the console for errors
      console.log(error);
    });
};

export const signOut = () => {
  myMSALObj.logout();
};

function acquireTokenPopupAndCallMSGraph(dispatch) {
  if (!dispatch) return;
  //Always start with acquireTokenSilent to obtain a token in the signed in user from cache
  myMSALObj
    .acquireTokenSilent(requestObj)
    .then(function (tokenResponse) {
      callMSGraph(
        graphConfig.graphMeEndpoint,
        tokenResponse.accessToken,
        graphAPICallback,
        dispatch
      );
    })
    .catch(function (error) {
      console.log(error);
      // Upon acquireTokenSilent failure (due to consent or interaction or login required ONLY)
      // Call acquireTokenPopup(popup window)
      if (requiresInteraction(error.errorCode)) {
        myMSALObj
          .acquireTokenPopup(requestObj)
          .then(function (tokenResponse) {
            callMSGraph(
              graphConfig.graphMeEndpoint,
              tokenResponse.accessToken,
              graphAPICallback,
              dispatch
            );
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    });
}

function callMSGraph(theUrl, accessToken, callback, dispatch) {
  var xmlHttp = new XMLHttpRequest();
  xmlHttp.onreadystatechange = function () {
    if (this.readyState == 4 && this.status == 200)
      callback(JSON.parse(this.responseText), dispatch);
  };
  xmlHttp.open("GET", theUrl, true); // true for asynchronous
  xmlHttp.setRequestHeader("Authorization", "Bearer " + accessToken);
  xmlHttp.send();
}

function graphAPICallback(data, dispatch) {
  if (!(typeof data.mail === "string" && data.mail.length)) {
    alert("You do not have access to this application!");
    return;
  }
  var header = {
    alg: "HS256",
    typ: "JWT",
  };
  var stringifiedHeader = CryptoJS.enc.Utf8.parse(JSON.stringify(header));
  var encodedHeader = base64url(stringifiedHeader);
  var stringifiedData = CryptoJS.enc.Utf8.parse(JSON.stringify(data));
  var encodedData = base64url(stringifiedData);
  var token = encodedHeader + "." + encodedData;
  // with secret

  var secret = "9Us5BmR1ovVvMX88CZ89AE435DYDJBAASDASDssudbfmOmOL3DLwAZJueWS";
  var signature = CryptoJS.HmacSHA256(token, secret);
  signature = base64url(signature);
  var signedToken = token + "." + signature;
  dispatch(loginRequest());
  const body = {
    cmd: "auth:ms-login",
    ms_token: signedToken,
    //  ms_token:
    //   "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJAb2RhdGEuY29udGV4dCI6Imh0dHBzOi8vZ3JhcGgubWljcm9zb2Z0LmNvbS92MS4wLyRtZXRhZGF0YSN1c2Vycy8kZW50aXR5IiwiYnVzaW5lc3NQaG9uZXMiOltdLCJkaXNwbGF5TmFtZSI6IlJpc2hhYmggTmlzaGFkIiwiZ2l2ZW5OYW1lIjoiUmlzaGFiaCIsImpvYlRpdGxlIjpudWxsLCJtYWlsIjoiUmlzaGFiaEBtb3Jkb3JpbnRlbGxpZ2VuY2UuY29tIiwibW9iaWxlUGhvbmUiOm51bGwsIm9mZmljZUxvY2F0aW9uIjpudWxsLCJwcmVmZXJyZWRMYW5ndWFnZSI6ImVuLVVTIiwic3VybmFtZSI6Ik5pc2hhZCIsInVzZXJQcmluY2lwYWxOYW1lIjoiUmlzaGFiaEBtb3Jkb3JpbnRlbGxpZ2VuY2UuY29tIiwiaWQiOiIzZGFhNmIwOS1jOTkyLTQzZWQtYjE1ZS04Y2NhMTQ4YmE5YzcifQ.yMVz-6JW4vFaqDBHaRhhWSJmlbJeg3UKcbsb8txOM7U",
  };

  axios({
    // method: 'post',
    // url: `${config.api.base_url}/api/auth/ms-login`,
    // data: { ms_token: signedToken }
    method: "POST",
    url: `${config.api_url}`,
    data: body,
    headers: {
      // "Access-Control-Allow-Headers":
      //   "access-control-allow-origin, Content-Type, access-control-allow-headers, Authorization, X-Requested-With",
      // "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
    },
  })
    .then((response) => {
      dispatch(loginSuccess(response.data.reply.user));
      sessionStorage.setItem(
        "user",
        JSON.stringify({
          data: response.data.reply.user,
        })
      );
      localStorage.setItem(
        "user",
        JSON.stringify({
          data: response.data.reply.user,
        })
      );
      sessionStorage.setItem("checkAuth", true);

      history.push("/home");
    })
    .catch((error) => {
      console.error(error);
      notification.error({
        duration: 2,
        message: "Error",
        description:
          "Login Failure. Please try again or contact an administrator.",
      });
      dispatch(loginFailure());
    });
}

function handleSuccess(response) {
  console.log("I got the responses as ", response.data);
  this.props.startLogin();
}

//This function can be removed if you do not need to support IE
function acquireTokenRedirectAndCallMSGraph() {
  //Always start with acquireTokenSilent to obtain a token in the signed in user from cache
  myMSALObj
    .acquireTokenSilent(requestObj)
    .then(function (tokenResponse) {
      callMSGraph(
        graphConfig.graphMeEndpoint,
        tokenResponse.accessToken,
        graphAPICallback
      );
    })
    .catch(function (error) {
      console.log(error);
      // Upon acquireTokenSilent failure (due to consent or interaction or login required ONLY)
      // Call acquireTokenRedirect
      if (requiresInteraction(error.errorCode)) {
        myMSALObj.acquireTokenRedirect(requestObj);
      }
    });
}

function authRedirectCallBack(error, response) {
  if (error) {
    console.log(error);
  } else {
    if (response.tokenType === "access_token") {
      callMSGraph(
        graphConfig.graphMeEndpoint,
        response.accessToken,
        graphAPICallback
      );
    }
  }
}

function requiresInteraction(errorCode) {
  if (!errorCode || !errorCode.length) {
    return false;
  }
  return (
    errorCode === "consent_required" ||
    errorCode === "interaction_required" ||
    errorCode === "login_required"
  );
}

function base64url(source) {
  // Encode in classical base64
  let encodedSource = CryptoJS.enc.Base64.stringify(source);

  // Remove padding equal characters
  encodedSource = encodedSource.replace(/=+$/, "");

  // Replace characters according to base64url specifications
  encodedSource = encodedSource.replace(/\+/g, "-");
  encodedSource = encodedSource.replace(/\//g, "_");

  return encodedSource;
}

// Browser check variables
var ua = window.navigator.userAgent;
var msie = ua.indexOf("MSIE ");
var msie11 = ua.indexOf("Trident/");
var msedge = ua.indexOf("Edge/");
var isIE = msie > 0 || msie11 > 0;
var isEdge = msedge > 0;

//If you support IE, our recommendation is that you sign-in using Redirect APIs
//If you as a developer are testing using Edge InPrivate mode, please add "isEdge" to the if check

// can change this to default an experience outside browser use
var loginType = isIE ? "REDIRECT" : "POPUP";

// runs on page load, change config to try different login types to see what is best for your application
if (loginType === "POPUP") {
  if (myMSALObj.getAccount()) {
    // avoid duplicate code execution on page load in case of iframe and popup window.

    acquireTokenPopupAndCallMSGraph();
  }
} else if (loginType === "REDIRECT") {
  document.getElementById("SignIn").onclick = function () {
    myMSALObj.loginRedirect(requestObj);
  };

  if (myMSALObj.getAccount() && !myMSALObj.isCallback(window.location.hash)) {
    // avoid duplicate code execution on page load in case of iframe and popup window.
    acquireTokenRedirectAndCallMSGraph();
  }
} else {
  console.error("Please set a valid login type");
}



// WEBPACK FOOTER //
// ./src/components/Login/MsLoginConfig.js